import { Stack, type SvgIconProps, Typography } from "@mui/material";
import { SignUpButtons } from "Components/Transactions/Anonymous/SignUpOptions/SignUpButtons";
import type { FC } from "react";
import { Resources, useResource } from "Translations/Resources";

const ComponentResources = Resources.Transactions.Anonymous;

type Props = {
  Icon: FC<SvgIconProps>;
  campaignName: string;
  iconColor?: string;
};

export const CampaignSignupOptions = ({
  Icon,
  campaignName,
  iconColor,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={4}>
      <Stack alignItems="center" gap={7}>
        <Icon sx={{ fontSize: "42px", color: iconColor || "primary.main" }} />
        <Typography fontSize="1rem" fontWeight={500} textAlign="center" px={4}>
          {t(ComponentResources.CampaignSignupTitle, { campaignName })}
        </Typography>
        <Typography
          fontSize="0.75rem"
          fontWeight={500}
          color="text.secondary"
          textAlign="center"
        >
          {t(ComponentResources.CampaignSignupDescription)}
        </Typography>
      </Stack>
      <SignUpButtons />
    </Stack>
  );
};
